import { render } from "./CofficientMatrix.vue?vue&type=template&id=106014db"
import script from "./CofficientMatrix.vue?vue&type=script&lang=js"
export * from "./CofficientMatrix.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__